import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import Fade from 'react-reveal/Fade';
import Button from '@material-ui/core/Button';
import ReactHtmlParser from 'react-html-parser';
import {withLocalize} from 'react-localize-redux';

class HomeEvents extends Component {
    render() {
        return (
            <section id="highlight-events" className="highlight-with-images">
                <div className="row">
                    <div className="col col-images col-12 col-md-5">
                        <Fade top>
                            <div className="image image-1 front top right">
                                {this.props.widgets.bloc3_image1 &&
                                    <img src={this.props.widgets.bloc3_image1.data.url} alt=""/>
                                }
                            </div>
                        </Fade>
                        <Fade bottom>
                            <div className="image image-2 back bottom left">
                                {this.props.widgets.bloc3_image2 &&
                                    <img src={this.props.widgets.bloc3_image2.data.url} alt=""/>
                                }
                            </div>
                        </Fade>
                    </div>
                    <div className="col col-content col-12 col-md-5 offset-0 offset-md-1 align-self-center">
                        {this.props.widgets.bloc3_titre &&
                            <h3>{ReactHtmlParser(this.props.widgets.bloc3_titre.data.content)}</h3>
                        }
                        {this.props.widgets.bloc3_contenu &&
                            <div className="content">{ReactHtmlParser(this.props.widgets.bloc3_contenu.data.content)}</div>
                        }
                        {this.props.widgets.bloc3_bouton &&
                            <Button variant="contained" color="primary" className="btn-more" component={props => <Link to={this.props.translate('routes.institutions')} {...props}/>}>
                                {this.props.widgets.bloc3_bouton.data.content}
                            </Button>
                        }
                    </div>
                </div>
            </section>
        );
    }
}

HomeEvents.propTypes = {
    widgets: PropTypes.object.isRequired,
};

export default withLocalize(HomeEvents);



// WEBPACK FOOTER //
// ./src/features/Home/components/HomeEvents.js